'use strict';

/**
 * Helper class for date formatting operations
 */
export class DateHelpers {
  /**
   * Formats date for API (YYYY-MM-DD)
   * Handles Date objects, ISO strings, and date strings
   * @param {Date|string} date - The date to format
   * @returns {string} Formatted date string (YYYY-MM-DD) or empty string if invalid
   */
  static formatDateForApi(date) {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * Formats date for display (MM/DD/YYYY)
   * Optionally uses dateFormattingHelper service if provided, otherwise uses fallback implementation
   * @param {Date|string} date - The date to format
   * @param {Object} dateFormattingHelper - Optional dateFormattingHelper service
   * @returns {string} Formatted date string (MM/DD/YYYY) or empty string if invalid
   */
  static formatDateForDisplay(date, dateFormattingHelper) {
    if (dateFormattingHelper && dateFormattingHelper.formatDateForDisplay) {
      return dateFormattingHelper.formatDateForDisplay(date);
    }
    
    if (!date) return '';
    
    if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const parts = date.split('-');
      return parts[1] + '/' + parts[2] + '/' + parts[0];
    }
    
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return '';
    }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return month + '/' + day + '/' + year;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/helpers/dateHelpers.js